// let http=$axios
import http from "./request";

// export function positionList(params) {
//     return http.get(`https://gw.chci.cn/hmcscommonapp/kq/sons`, { params });
//   }
// export function getMessage(params){
//     return http.get("/agents/checkAgent/findByLayer", { params });
// }

// 左侧导航的接口
export const navList = (params, SSOID) =>
  http({
    method: "get",
    url: "/apis/hmcsFinance/user/getAuthority?SSOID=" + SSOID,
    params: params,
  });
// 登录之后调一下登录日志的接口
export const loginLog = (fordata,SSOID) => http({
    method: "post",
    url: "/apis/hmcsFinance/log/addOperateLog?SSOID="+SSOID,
    // data:new URLSearchParams(fordata)
    data:fordata
})
